import LazyLoad from "vanilla-lazyload";

var winWidth = $(window).width();

if ( $('.team--item').length > 0 ) {

  var lazyLoadTeamItems = new LazyLoad();

  $('.team--item--link').on('click',function(e) {

    e.preventDefault();
    var href = $(this).attr('href');
    
    $(href).addClass('is-showing');

  });

  $('.team--item--modal--close').on('click',function(e) {

    e.preventDefault();
    $('.team--item--modal').removeClass('is-showing');

  });

  $('.team--item--modal--next').on('click',function(e) {

    e.preventDefault();
    var id = $(this).data('id');
    var next = $('#'+id).next('div');
    
    if (next) {
      $('.team--item--modal').removeClass('is-showing');
      next.addClass('is-showing');
    }

  });

  $('.team--item--modal--previous').on('click',function(e) {

    e.preventDefault();
    var id = $(this).data('id');
    var previous = $('#'+id).prev('div');
    
    if (previous) {
      $('.team--item--modal').removeClass('is-showing');
      previous.addClass('is-showing');
    }

  });

}



